import { useEffect, useState } from "react";
import { toast } from "sonner";
import { TYPES_DOSSIER } from "@/lib/dossiers";
import { fetchTemplates, saveTemplate } from "@/lib/templates";
import PromptEditor from "@/components/prompts/PromptEditor";
import { cn } from "@/lib/utils";

export default function PromptsIa() {
    const [templates, setTemplates] = useState({});
    const [selected, setSelected] = useState(TYPES_DOSSIER[0].value);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTemplates()
            .then(setTemplates)
            .catch((e) => toast.error("Chargement impossible", { description: e.message }))
            .finally(() => setLoading(false));
    }, []);

    async function save(type, prompt) {
        try {
            const row = await saveTemplate(type, prompt);
            setTemplates((t) => ({ ...t, [type]: row }));
            toast.success("Prompt enregistré", { description: "Utilisé pour les prochaines synthèses." });
        } catch (e) {
            toast.error("Enregistrement impossible", { description: e.message });
            throw e;
        }
    }

    return (
        <div data-testid="prompts-ia-page" className="space-y-10">
            <header className="border-b border-border pb-8">
                <p className="text-xs uppercase tracking-[0.22em] text-muted-foreground">Paramétrage IA</p>
                <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-foreground">
                    Prompts <span className="italic text-muted-foreground">système</span>
                </h1>
                <p className="mt-4 max-w-xl text-sm text-muted-foreground">
                    Un prompt par type de mandat. Il cadre le rôle, la structure et le ton de la synthèse générée par Gemini.
                    Chaque enregistrement crée une nouvelle version ; la plus récente est utilisée.
                </p>
            </header>

            <div className="grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-8">
                <nav data-testid="prompt-types-nav" className="flex flex-col gap-1">
                    {TYPES_DOSSIER.map((t) => {
                        const has = Boolean(templates[t.value]);
                        return (
                            <button
                                key={t.value}
                                type="button"
                                data-testid={`prompt-type-${t.value}`}
                                onClick={() => setSelected(t.value)}
                                className={cn(
                                    "flex items-center justify-between text-left px-4 py-2.5 rounded-md text-sm transition-colors",
                                    selected === t.value ? "bg-primary text-primary-foreground" : "text-foreground hover:bg-accent"
                                )}
                            >
                                {t.label}
                                <span className={cn("h-2 w-2 rounded-full", has ? "bg-emerald-400" : selected === t.value ? "bg-white/40" : "bg-border")} title={has ? "Personnalisé" : "Prompt par défaut"} />
                            </button>
                        );
                    })}
                </nav>

                {loading ? (
                    <p className="text-sm text-muted-foreground">Chargement…</p>
                ) : (
                    <PromptEditor key={selected} type={TYPES_DOSSIER.find((t) => t.value === selected)} template={templates[selected]} onSave={save} />
                )}
            </div>
        </div>
    );
}
